import { render, staticRenderFns } from "./RewardfulAlert.vue?vue&type=template&id=16e63d72"
import script from "./RewardfulAlert.vue?vue&type=script&lang=js"
export * from "./RewardfulAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports